import { FC } from "react"

import { DropdownMenu } from "../../inputs/DropdownMenu"

type BonusOption = {
  id: string
  title: string
}

type BonusOfferSelectionProps = {
  bonusId?: string
  bonuses: BonusOption[]
  onChange: (bonusId: string) => void
  onCreate: () => void
  error?: string
  touched?: boolean
  savedPromo?: { id: string; title: string } | null
}

export const BonusOfferSelection: FC<BonusOfferSelectionProps> = ({ bonusId, bonuses, onChange, onCreate, error, touched }) => {
  return (
    <div className="flex gap-2 mt-4 justify-between items-center">
      <div className="flex flex-col gap-2">
        <span className="label-text">Select Existing Bonus Offer</span>

        <DropdownMenu
          id="bonus"
          options={bonuses.map((b) => ({
            name: b.title,
            value: b.id
          }))}
          value={bonusId ?? ""}
          onChange={(e: any) => onChange(e.target.value)}
          placeholder="Please choose an option"
          invalid={Boolean(touched && error)}
          altLabelOne={touched ? error ?? "" : ""}
        />
      </div>

      <div className="h-[60px] w-[1px] bg-[#a6adba]" />

      <div className="flex flex-col gap-2">
        <span className="label-text">Create new Bonus Offer</span>
        <button
          type="button"
          className="btn btn-primary bg-transparent text-[rgba(169,78,206,1)] border-[rgba(169,78,206,0.8)]"
          onClick={onCreate}
        >
          Create
        </button>
      </div>
    </div>
  )
}
